import React from 'react';
import {
    View,
    Text,
    Image,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    Platform,
    Linking
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/simulacaoSucessoStyles';
import { useLogScreen } from '../../useLogScreen';
export default function SolicitacaoAnaliseSucessoWeb({route}) {
    useLogScreen('AnaliseSuccessScreen');
    const navigation = useNavigation();
    const {  imprimir_link } = route.params || {};

    return (
        <BaseWeb>
            {(userInfo) => (
                <KeyboardAvoidingView
                    style={{ flex: 1 }}
                    behavior={Platform.OS === 'ios' ? 'padding' : undefined}
                    enabled={Platform.OS !== 'web'}
                >
                    <ScrollView contentContainerStyle={styles.container}>
                        <Image
                            source={require('../../assets/img/stape6_laranja.png')}
                            style={styles.image}
                            resizeMode="contain"
                        />
                        <Text style={styles.title}>Solicitação feita com sucesso</Text>
                        <Text style={styles.subtext}>Sua solicitação de análise de certidões foi realizada com sucesso! Em até 24 horas, a sua avaliação estará finalizada. Enviaremos a análise para o seu e-mail assim que estiver disponível. Você também poderá baixar as análises concluídas diretamente pelo aplicativo.</Text>

                        <TouchableOpacity style={styles.button}  onPress={() => navigation.navigate('AnaliseDeCertidoesWeb')}>
                            <Text style={styles.buttonText}>Continuar</Text>
                        </TouchableOpacity>
                    </ScrollView>
                </KeyboardAvoidingView>
            )}
        </BaseWeb>
    );
}
